
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@/components/theme-provider';

const Stores = () => {
  const navigate = useNavigate();
  
  // Rediriger vers le tableau de bord puisque la section boutiques est maintenant intégrée
  useEffect(() => {
    navigate('/dashboard/shops');
  }, [navigate]);

  return (
    <ThemeProvider>
      <div className="h-full w-full overflow-hidden font-sans">
        {/* Cette page redirige vers les boutiques */}
      </div>
    </ThemeProvider>
  );
};

export default Stores;
